import { defaultStatus } from '@/_schemas/status-input';
import type { RouteListItem } from '@/types';

import { type BillingSystemFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues: Readonly<BillingSystemFormSchema> = {
  id: -1,
  name: '',
  status: defaultStatus,
} as const;

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/billing-systems', name: 'Billing Systems' },
];
